import AppRoot from '../../../external/post-list-widget/containers/app-root';
import { withViewer } from '../../../external/common/hoc/with-viewer';
import { withReduxStore } from '../../../external/common/components/runtime-context/with-redux-store';

export default withViewer(withReduxStore(AppRoot));
